import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { ICallQueue } from 'src/app/models/icall-queue';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private _menuItems: MenuItem[] = [];
  get menuItems():MenuItem[]
  {
    return this._menuItems;
  }
  set menuItems(menuItem:MenuItem[]){
    this._menuItems = menuItem;
    //this.translateItems(this.menuItems);
  }
  callQueue :ICallQueue;
  clinicTypeId:number = null;
  specialtyId:number = null;
  numberOfSpecialty:number = null;
  imageUrl:string = null;
  clinicName:string = "";
  doctorName:string = "";
  totalRate:number = 0;
  price:number = 0;
  currencyName:string = "";
  timeSlot : string[] = [];
  addtionalData:any;
  uploadedFiles:any=[];
  constructor(private translate:TranslateService) {
    this.callQueue  =  
    {
      Id:0,
      AppointmentDate:new Date(),
      ClinicID:null,
      MobileDoctorPath: null,
      PortalPaymentOption:null,
      ProviderID:null,
      ServiceId:null,
      PatientId: +localStorage.getItem('PatientId'),
      AppointmentDateNote:"",
      Area:"",
      AppointmentTime:"",
      CreationDate:new Date(),
      AppointmentTimeNote:"",
      Comment:"",
      MultiAttachment:false,
      ImagePath:"",
      IsEmergency:false,
      IsPayment:true,
      PatientName:"",
      RequestType:0,
      TimeZoneOffset:0
    };
  }
  // translateItems(items:any[]){
  //   for(let i=0; i<items.length; i++){
  //       this.translate.get(items[i].label).subscribe(res=>{
  //           items[i].label = res;
  //           if(items[i].items != undefined){
  //               this.translateItems(items[i].items);
  //           }
  //       })
  //     }
  // }
}
